import moment from 'moment'
import 'moment/locale/ko'

import { useEffect, useState } from 'react'

const getHappyData = () => {
  const storeInfo = {
    closedDay: localStorage.getItem('closedDay'),
    happyorderYn: localStorage.getItem('happyorderYn'),
    shopHoursStart: localStorage.getItem('shopHoursStart'),
    shopHoursEnd: localStorage.getItem('shopHoursEnd'),
  }

  return checkOpen(storeInfo)
}

const checkOpen = (storeInfo) => {
  let {
    closedDay, // 휴무일
    happyorderYn, // 해피오더
    shopHoursStart, // 운영시간 시작
    shopHoursEnd, // 운영시간 마감
  } = storeInfo

  const currentDay = moment().format('YYYYMMDD') // 오늘
  const currentTime = moment().format('HHmm') // 현재 시간

  // 영업시간 시작
  const shopHoursStartTime = moment({
    hour: !shopHoursStart
      ? '00'
      : shopHoursStart.length === 4
      ? shopHoursStart.slice(0, 2)
      : shopHoursStart.slice(0, 1),
    minute: !shopHoursStart
      ? '00'
      : shopHoursStart.length === 4
      ? shopHoursStart.slice(2, 4)
      : shopHoursStart.slice(1, 4),
  }).format('HHmm') // 영업 시작 시간

  // 영업시간 마감
  const shopHoursEndTime = moment({
    hour: !shopHoursEnd
      ? '00'
      : shopHoursEnd.length === 4
      ? shopHoursEnd.slice(0, 2)
      : shopHoursEnd.slice(0, 1),
    minute: !shopHoursEnd
      ? '00'
      : shopHoursEnd.length === 4
      ? shopHoursEnd.slice(2, 4)
      : shopHoursEnd.slice(1, 4),
  }).format('HHmm') // 영업 시작 시간

  if (closedDay !== 'null' && closedDay?.includes(currentDay)) {
    return false
  }
  // 휴무일 아니고
  else {
    // 해피오더 켜짐 or 영업시간 내
    if (
      happyorderYn === 'Y' ||
      (shopHoursStartTime <= currentTime && shopHoursEndTime >= currentTime)
    ) {
      return true
    } else {
      return false
    }
  }
}

export const useHappyOrder = () => {
  const [happyOrder, setHappyOrder] = useState(getHappyData())

  useEffect(() => {
    const handleChangeStorage = () => {
      setHappyOrder(getHappyData())
    }

    window.addEventListener('storage', handleChangeStorage)

    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  return happyOrder
}
